import { Position } from '../types';
import type { HandleBound, XYPosition } from '../types';

const HALF = 0.5;

/** Where an edge attaches to a handle: the middle of the handle's outer side, in flow space. */
export const getHandlePoint = (handle: Readonly<HandleBound>, nodePosition: XYPosition): XYPosition => {
  const x = nodePosition.x + handle.x;
  const y = nodePosition.y + handle.y;
  switch (handle.position) {
    case Position.Top:
      return { x: x + handle.width * HALF, y };
    case Position.Right:
      return { x: x + handle.width, y: y + handle.height * HALF };
    case Position.Bottom:
      return { x: x + handle.width * HALF, y: y + handle.height };
    case Position.Left:
      return { x, y: y + handle.height * HALF };
  }
};
